import React from "react";
import {
  Mic,
  MicOff,
  Camera,
  MonitorOff,
  Monitor,
  PhoneOff,
  VideoOff,
} from "lucide-react";

const CallControls = ({
  isMuted,
  isScreenSharing,
  isCameraOn,
  toggleMute,
  toggleCamera,
  startScreenShare,
  endCall,
  isTogglingCamera,
  disabled = false, // ADD THIS PROP
}) => {
  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={toggleMute}
        disabled={disabled} // ADD THIS
        className={`p-3 rounded-full ${
          disabled
            ? "bg-gray-700 cursor-not-allowed opacity-50"
            : isMuted
              ? "bg-red-600"
              : "bg-gray-700 hover:bg-gray-600"
        }`}
        title={disabled ? "Reconnecting..." : isMuted ? "Unmute" : "Mute"}
      >
        {isMuted ? <MicOff size={22} /> : <Mic size={22} />}
      </button>

      <button
        onClick={toggleCamera}
        disabled={disabled || isTogglingCamera} // ADD disabled
        className={`p-3 rounded-full ${
          disabled || isTogglingCamera
            ? "bg-gray-700 cursor-not-allowed opacity-50"
            : isCameraOn
              ? "bg-gray-800 hover:bg-gray-700"
              : "bg-red-600 hover:bg-red-700"
        } transition-colors`}
        title={disabled ? "Reconnecting..." : ""}
      >
        {isTogglingCamera ? (
          <span className="flex items-center justify-center w-6 h-6">
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </span>
        ) : isCameraOn ? (
          <Camera className="w-6 h-6 text-white" />
        ) : (
          <VideoOff className="w-6 h-6 text-white" />
        )}
      </button>

      <button
        onClick={startScreenShare}
        disabled={disabled} // ADD THIS
        className={`p-3 rounded-full ${
          disabled
            ? "bg-gray-700 cursor-not-allowed opacity-50"
            : isScreenSharing
              ? "bg-gray-800 hover:bg-gray-700"
              : "bg-red-600 hover:bg-red-700"
        }`}
        title={
          disabled
            ? "Reconnecting..."
            : isScreenSharing
              ? "Stop presenting"
              : "Present now"
        }
      >
        {isScreenSharing ? <Monitor size={22} /> : <MonitorOff size={22} />}
      </button>

      {/* End call button - Keep enabled so users can always leave */}
      <button
        onClick={endCall}
        className="p-3 rounded-full bg-red-600 hover:bg-red-700"
        title="End call"
      >
        <PhoneOff size={22} />
      </button>
    </div>
  )
}

export default CallControls